import { useFeatureFlag } from '@hooks/useFeatureFlag'
import { FEATURE_FLAGS, VARIANT_KEYS } from 'src/constants/featureFlags'

export const useIsSuggestedTreatment = () => {
  const { value } = useFeatureFlag(FEATURE_FLAGS.SUGGESTED_TREATMENTS_SCREEN)
  const isSuggestedTreatmentTest = value === VARIANT_KEYS.TEST

  return isSuggestedTreatmentTest
}
